/* eslint-disable */
import {
    IBackboneHotelOffer, IBackboneTour, IBackboneRailwayTour, TBackboneProductCommon, IBackboneProduct,
} from '@ve/types/backboneModels/Domain/ObjectValue';
import {
    IReturnProductTour, IReturnProductType, IReturnProductHotelOffer, IReturnProductRailways,
} from '@ve/pages/hotel/types';

    const getFromDate = (model: any) => {
        if ((model.get('type') === 'TourProduct' || model.get('type') === 'RailwayTourProduct')
        && model.get('product').get('routes').length && model.get('product').get('routes')[0].there?.legs?.[0].departureDate
    ) {
        return model.get('product').get('routes')[0].there.legs[0].departureDate.substr(0, 10); //to cut time
    }
    return model.get('product').get('checkInDate');
    }

const adaptMainProduct = (product: IBackboneProduct): Partial<IReturnProductType> => ({
    startDate: getFromDate(product),
    isExclusive: product.get('isExclusive'),
    id: product.get('id'),
    firstPaymentDefinition: Object.freeze(product.get('firstPaymentDefinition')),
    firstPaymentDefinitions: product.get('allFirstPaymentDefinitions')?.map(( firstPaymentDefinition ) => Object.freeze(firstPaymentDefinition)) || [],
});

const adaptCommonProduct = (product: TBackboneProductCommon): Partial<IReturnProductType> => ({
    checkInDate: product.get('checkInDate'),
    nightInHotel: product.get('nightsInHotel'),
    nights: product.get('nights'),
    operator: Object.freeze(product.get('operator')),
    price: product.get('price'),
    checkInDateRange: {
        from: product.get('checkInDateRange').get('from'),
        to: product.get('checkInDateRange').get('to'),
    },
    room: product.get('room'),
    hotel: product.get('hotel'),
    meal: {
        id: product.get('meal').get('id'),
        code: product.get('meal').get('code'),
        name: product.get('meal').get('name'),
    },
    hotelAvailable: product.get('hotelAvailable'),
    touristGroup: Object.freeze(product.get('touristGroup')),
    originalPrice: product.get('originalPrice'),
    discount: product.get('discount'),
    percentPrepayment: product.get('percentValue'),
});

const AdaptTour = (product: IBackboneTour): IReturnProductTour => ({
    ...adaptCommonProduct(product) as IReturnProductType,
    price: product.get('priceWithOilTax'),
    type: 'TourProduct',
    routes: product.get('routes'),
});

const AdaptHotelOffer = (product: IBackboneHotelOffer): IReturnProductHotelOffer => ({
    ...adaptCommonProduct(product) as IReturnProductType,
    type: 'HotelOfferProduct',
    firstPaymentDefinitions: product.get('allFirstPaymentDefinitions')?.map(( firstPaymentDefinition ) => Object.freeze(firstPaymentDefinition)) || [],
    cancellationPolicy: product.get('cancellationPolicy'),
});

const AdaptRailway = (product: IBackboneRailwayTour): IReturnProductRailways => ({
    ...adaptCommonProduct(product) as IReturnProductType,
    type: 'RailwayTourProduct',
    routes: product.get('routes'),
    firstPaymentDefinitions: product.get('firstPaymentDefinitions')?.map(( firstPaymentDefinition ) => Object.freeze(firstPaymentDefinition)) || [],
});

export default function FactoryProductsAdapt<T extends IReturnProductType>(product: IBackboneProduct | null): T | null {
    if (!product) return null;
    if (product.get('type') === 'HotelOfferProduct') {
        const hotelOfferProduct: IBackboneHotelOffer = product.get('product');
        // @ts-ignore: Unreachable code error
        return { ...adaptMainProduct(product), ...AdaptHotelOffer(hotelOfferProduct)};
    }
    if (product.get('type') === 'TourProduct') {
        const tourProduct: IBackboneTour = product.get('product');
        // @ts-ignore: Unreachable code error
        return { ...adaptMainProduct(product), ...AdaptTour(tourProduct)};
    }
    if (product.get('type') === 'RailwayTourProduct') {
        const railwayProduct: IBackboneRailwayTour = product.get('product');
        // @ts-ignore: Unreachable code error
        return { ...adaptMainProduct(product), ...AdaptRailway(railwayProduct)};
    }
    return null;
};